import { HttpService, VisibaHttpOption } from '@application/http.service';
import { UniversalConfig } from '@application/universal_config.service';
import type { GetRepresentativeNinApiModel } from '@visiba/api-vcs-general';
import { Injectable } from '@visiba/instantiation';
import { ApiBase } from './_api_base';

interface AccessInfo {
	active: boolean;
	isOpen: boolean;
	closedReason: string;
}

@Injectable()
export class RedRobinApiService extends ApiBase {
	constructor(
		private readonly httpService: HttpService,
		private readonly universalConfig: UniversalConfig,
	) {
		super('general');
	}

	public getRepresentativeNin(sessionId: string) {
		return this.httpService.get<GetRepresentativeNinApiModel>(`${this.baseUri}/RedRobin/${sessionId}/GetRepresentativeNin`);
	}

	public getOpenStatus() {
		return this.httpService.get<AccessInfo>(`/client/v2/units/${this.universalConfig.currentUnitId}/RedRobin/accessInfo`);
	}

	public getSessionLink(sessionId: string) {
		const httpOptions = new VisibaHttpOption(this.universalConfig, { parseAs: 'text' });
		return this.httpService.get<string>(
			`/client/v2/units/${this.universalConfig.currentUnitId}/RedRobin/session/${sessionId}/entryUrl`,
			httpOptions,
		);
	}
}
